import * as React from 'react';
import { SVGProps } from 'react';

const IconExitSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 20H3V4h13v5h-2V6H5v12h9v-3h2v5Z" />
    <path d="m18 16 4-4-4-4v3H9v2h9v3Z" />
  </svg>
);
export default IconExitSizeM;
